import { EntryCollection, Entry, Asset, Sys } from 'contentful';
import { Dialogtree } from 'types/Encounter';

import { getEntries, getEntry } from './ContentfulClient';

type ContentfulEncounter = {
  id: string;
  title: string;
  background: Asset;
  foreground: Asset;
  characters: object[];
  dialog: Dialogtree;
  backgroundMusic: Asset;
  sys: Sys;
  order: number;
  slug: string;
};

// todo: make it DRY
const transformEncounters = (encounter: EntryCollection<ContentfulEncounter>) => {
  return encounter.items.map(({ sys, fields }) => {
    const { title, background, foreground, characters, dialog, backgroundMusic, order, slug } =
      fields;
    const id = sys.id;

    return {
      id,
      title,
      bgUrl: background?.fields?.file?.url || '',
      fgUrl: foreground?.fields?.file?.url || '',
      characters,
      dialog,
      bgMusic: backgroundMusic?.fields?.file?.url || '',
      date: sys.updatedAt,
      order,
      slug,
    };
  });
};

const transformEncounter = (encounter: Entry<ContentfulEncounter>) => {
  const { sys, fields } = encounter;
  const { title, background, foreground, characters, dialog, backgroundMusic, order, slug } =
    fields;

  return {
    id: sys.id,
    title,
    bgUrl: background?.fields?.file?.url || '',
    fgUrl: foreground?.fields?.file?.url || '',
    characters,
    dialog,
    bgMusic: backgroundMusic?.fields?.file?.url || '',
    date: sys.updatedAt,
    order,
    slug,
  };
};

export const getAllEncounter = async () => {
  return transformEncounters(await getEntries<ContentfulEncounter>('encounter'));
};

export const getOneEncounter = async (slug: string) => {
  return transformEncounter(await getEntry<ContentfulEncounter>(slug));
};
